import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

const STAGES = [
  "BRAINSTORM",
  "BRIEFING",
  "GENERATING",
  "REVIEW",
  "SCHEDULING",
  "PUBLISHED",
  "ANALYTICS",
];

export function PipelineStageIndicator({
  currentStage,
  className,
}: {
  currentStage: string;
  className?: string;
}) {
  const { t } = useTranslation("common");
  const currentIdx = STAGES.indexOf(currentStage);

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {STAGES.map((stage, idx) => {
        const isCompleted = idx < currentIdx;
        const isCurrent = idx === currentIdx;
        return (
          <div key={stage} className="flex items-center gap-1">
            {idx > 0 && (
              <div
                className={cn(
                  "h-px w-4",
                  isCompleted ? "bg-primary" : "bg-muted",
                )}
              />
            )}
            <div
              className={cn(
                "flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
                isCurrent && "bg-primary text-primary-foreground",
                isCompleted && "bg-primary/10 text-primary",
                !isCurrent && !isCompleted && "bg-muted text-muted-foreground",
              )}
            >
              {isCompleted && <Check size={10} />}
              {t(`pipelineStage.${stage}`)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
